import { render, staticRenderFns } from "./OrderConfirmationB2C.vue?vue&type=template&id=871ca440&scoped=true&"
import script from "./OrderConfirmationB2C.vue?vue&type=script&lang=ts&"
export * from "./OrderConfirmationB2C.vue?vue&type=script&lang=ts&"
import style0 from "./OrderConfirmationB2C.vue?vue&type=style&index=0&id=871ca440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871ca440",
  null
  
)

export default component.exports